<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-exchange-sidebar>
  <app-crud-table #ccCrudTable body [crudService]="crudService"
                   [transPartKey]="'contract'" [fieldId]="'id'" [fieldName]="'code'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   (dialogFormVisibleChange)="$event?onFormShow():{}"
                   [formLoading]="formLoading"
                   [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                   [writeRoles]="CCRoles.ROLES_EXCHANGE_WRITE"
                   [prepareForEdit]="prepareRecordForEdit" [prepareForClone]="prepareRecordForClone"
                   [lazyLoadOnInit]="true"
                   [defaultSortOrder]="1" [defaultSortField]="'id'" [totalRecords]="totalRecords"
  ></app-crud-table>
</app-exchange-sidebar>
